const REDACTED = '[REDACTED]';
const CPF_PLACEHOLDER = '[CPF]';

const SECRET_PARAM =
  /\b(new_password|code|api_key|access_token|token|player|state|session_state)=[^&#\s"']*/g;
const FORMATTED_CPF = /\d{3}\.\d{3}\.\d{3}-\d{2}/g;
// Sem lookbehind: Safari < 16.4 não aceita e o erro de parse derrubaria o bundle.
const PLAIN_CPF = /(^|\D)\d{11}(?!\d)/g;

export const redactText = (text: string): string =>
  text
    .replace(SECRET_PARAM, (_match, name) => `${name}=${REDACTED}`)
    .replace(FORMATTED_CPF, CPF_PLACEHOLDER)
    .replace(PLAIN_CPF, `$1${CPF_PLACEHOLDER}`);

const isPlainObject = (value: unknown): value is Record<string, unknown> => {
  if (typeof value !== 'object' || value === null) return false;
  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
};

export const redactSensitive = <T>(value: T): T => {
  if (typeof value === 'string') return redactText(value) as unknown as T;
  if (Array.isArray(value)) {
    return value.map(item => redactSensitive(item)) as unknown as T;
  }
  if (isPlainObject(value)) {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, redactSensitive(item)]),
    ) as T;
  }
  return value;
};
